<template>
  <sa-page-layout :titolo="titolo" :pathResource="pathResource" :linkback="linkback" :data="jsonData" :btnAnnullaVisible="true" :btnSaveVisible="true" :showModalLoading="showModalLoading" class="sa-no-space">
    <template slot="table-body">
      <div class="sa-tab-scroll">
        <b-row>
          <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
            <label class="sa-label-data">Struttura Riferimento</label>
            <b-form-select v-model="jsonData.codiceStruttura" :options="struttureRiferimentoOptions" :value="null" :disabled="true" value-field="denominazione" text-field="denominazione">
              <template #first>
                <b-form-select-option :disabled="true" :value="null">- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Report Name</label>
            <b-form-input v-model="jsonData.reportName" :disabled="true"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
            <label class="sa-label-data">Nome File</label>
            <b-form-select v-model="jsonData.nomeFile" :options="nomiFileOptions" :value="null" value-field="value" :disabled="true" text-field="text">
              <template #first>
                <b-form-select-option :disabled="true" :value="null">- Seleziona Nome File -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col class="text-center" cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
            <label class="sa-label-data">File</label>
            <b-button size="sm" v-b-tooltip.hover title="Scegli File" variant="outline-primary" @click="onClickFileIcon()">
              <font-awesome-icon icon="file" />
            </b-button>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Descrizione</label>
            <b-form-input v-model="jsonData.descrizione"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
            <label class="sa-label-data">Versione</label>
            <b-form-input v-model="jsonData.versione" :disabled="true"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
            <label class="sa-label-data">Stato</label>
            <b-form-select v-model="jsonData.stato" :options="statiReportOptions" :disabled="true" :value="null" value-field="value" text-field="text">
              <template #first>
                <b-form-select-option :disabled="true" :value="null">- Seleziona Stato -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-label-data">Test Data (JSON)<font-awesome-icon icon="times-circle" style="color: #c82333 !important" v-if="jsonError" /> <font-awesome-icon style="color: #218838 !important" icon="check-circle" v-else /></label>
            <b-form-textarea v-model="jsonData.testData" no-resize rows="30"></b-form-textarea>
          </b-col>
        </b-row>
      </div>
    </template>
    <template slot="table-footer">
      <b-modal ref="mdlStrutturaSelect" no-close-on-esc no-close-on-backdrop hide-header-close centered size="medium" style="height: 100% !important">
        <template #modal-title>
          <span><font-awesome-icon icon="file" /> Carica File .jasper</span>
        </template>
        <template #default>
          <b-row>
            <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
              <label class="sa-label-data">Struttura Riferimento </label>
              <b-form-select v-model="selectStrutturaModal" :options="struttureRiferimentoOptions" :value="null" :disabled="isVersioning" value-field="codiceStruttura" text-field="denominazione" @change="onChangeStrutturaSelezionata()">
                <template #first>
                  <b-form-select-option :disabled="true" :value="null">- Seleziona -</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
              <label class="sa-label-data">File .jasper</label>
              <print-report-import-file-component v-if="isStrutturaSelezionataModal" :jsonData="jsonDataReport" @update="onUploadReport" :key="keyImport"></print-report-import-file-component>
              <span v-else class="mb-3 mt-3">Seleziona Prima Struttura</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <strong>{{ messageErrorUpdateVersion }}</strong>
            </b-col>
          </b-row>
        </template>
        <template #modal-footer>
          <b-button size="sm" v-b-tooltip.hover title="Annulla e torna alla lista" variant="outline-danger" @click="onAnnulla()">
            Annulla
            <font-awesome-icon icon="times-circle" />
          </b-button>
          <b-button size="sm" v-b-tooltip.hover title="Conferma" variant="outline-info" :disabled="!isOKFileUpload" @click="onConfermaFile()">
            Conferma
            <font-awesome-icon icon="plus" />
          </b-button>
        </template>
      </b-modal>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PrintReportImportFileComponent from "../../../app/printreport/components/PrintReportImportFileComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
  components: { SaPageLayout, PrintReportImportFileComponent },
  mixins: [UtilityMixin],
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.loadData();
    me.loadStruttureRiferimento();
    me.jsonData.stato = "ATTIVO";
    me.jsonData.versione = 1;
    me.linkback = "/printserver";
    me.$refs.mdlStrutturaSelect.show();
  },
  data() {
    return {
      keyImport: 0,
      titolo: "Print Server Edit",
      pathResource: "/printserver",
      pathResourceStampa: "/print/createreport",
      stampaReport: null,
      messageErrorUpdateVersion: "",
      jsonDataReport: {},
      isReportUpdateNotValid: false,
      showModalLoading: false,
      isNuovaVersioneI: false,
      linkback: null,
      isVersioning: false,
      struttureRiferimentoOptions: [],
      jsonReportNameVersioning: {},
      id: "",
      jsonError: false,
      isOKFileUpload: false,
      isStrutturaSelezionataModal: false,

      selectStrutturaModal: null,
      linkNomiFile: "/printserver/nomifile",
      jsonData: {
        nomeFile: null,
        stato: null,
        codiceStruttura: null,
        reportName: null,
        testData: "{}",
      },
      statiReportOptions: [
        { value: "ATTIVO", text: "ATTIVO" },
        { value: "SOSPESO", text: "SOSPESO" },
        { value: "OBSOLETO", text: "OBSOLETO" },
      ],
      nomiFileOptions: [],
    };
  },
  computed: {
    isNewElement() {
      let me = this;
      if (me.id === "-1") {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      if (me.isNewElement) {
        me.showModalLoading = false;
      } else {
        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
        UtilityMixin.methods.restCallGet(link + me.id, {}, me.loadDataSuccessResponse, me.loadDataErrorResponse);
      }
    },
    loadDataSuccessResponse(response) {
      let me = this;
      if (response.data.data) console.log(response);

      me.jsonData = response.data.data;
      me.jsonData.id = "-1";
      me.jsonData.versione += 1;
      me.isVersioning = true;
      me.selectStrutturaModal = me.jsonData.codiceStruttura;
      me.showModalLoading = false;
    },

    loadDataErrorResponse(error) {
      console.log(error);
    },

    loadDataByNomeReport(nomeFile) {
      let me = this;
      me.showModalLoading = true;
      let filtro = {
        nomeFile: nomeFile,
        forPage: 100,
        page: 1,
      };
      let isReport = false;
      let linkReport = process.env.VUE_APP_PATH_API + me.pathResource;
      axios.get(linkReport, { params: filtro }).then((response) => {
        if (response.data.data.recordsNumber > 0) {
          me.jsonData = response.data.data.list[0];
          isReport = true;
        }
      });
      if (!isReport) {
        let linkSubReport = process.env.VUE_APP_PATH_API + "/printserversubreport";
        axios.get(linkSubReport, { params: filtro }).then((response) => {
          if (response.data.data.recordsNumber > 0) {
            let subReport = response.data.data.list[0];
            console.log("sub report");

            me.$router.push("/printserversubreport/edit/" + subReport.id);
          }
        });
      }
    },

    loadDataListaReport() {
      let me = this;
      me.showModalLoading = true;
      if (me.id === "-1") {
        me.showModalLoading = false;
      } else {
        let link = process.env.VUE_APP_PATH_API + me.pathResource;
        axios.get(link).then((response) => {
          me.jsonData = response.data.data;
          me.jsonData.id = "-1";
          me.jsonData.versione += 1;
          me.showModalLoading = false;
        });
      }
    },

    loadStruttureRiferimento() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + "/strutture";
      UtilityMixin.methods.restCallGet(link, {}, me.loadStruttureRiferimentoSuccess, me.loadStruttureRiferimentoError);
    },
    loadStruttureRiferimentoSuccess(response) {
      let me = this;
      if (response.data) me.struttureRiferimentoOptions = response.data.data;
      me.showModalLoading = false;
    },
    loadStruttureRiferimentoError(error) {
      let me = this;
      console.log(error);
      me.showModalLoading = false;
    },

    onClickFileIcon() {
      let me = this;
      me.$refs.mdlStrutturaSelect.show();
      me.jsonDataReport = {
        name: "",
      };
      me.nomiFileOptions = [];
      me.jsonData.nomeFile = null;
      me.jsonData.stato = "ATTIVO";
    },

    onChangeStrutturaSelezionata() {
      let me = this;
      me.jsonDataReport = {
        nome: "",
      };
      me.keyImport++;
      me.messageErrorUpdateVersion = "";
    },
    onAnnulla() {
      let me = this;
      me.$refs.mdlStrutturaSelect.hide();
      me.$router.push(me.linkback);
    },
    onUploadReport(data) {
      let me = this;
      me.jsonDataReport = {};
      me.jsonDataReport = data;
      let nomeReportInserito = me.jsonDataReport.name.replace(".jasper", "");
      if (!me.isNewElement) {
        if (me.jsonData.reportName != nomeReportInserito) {
          me.messageErrorUpdateVersion = ` ${me.jsonData.reportName} e ${nomeReportInserito} non coincidono. Carica il file corretto!`;
          me.isOKFileUpload = false;
        } else {
          me.messageErrorUpdateVersion = "";
          me.isOKFileUpload = true;
        }
      } else {
        if (me.nomiFileOptions.length > 0) {
          for (let report of me.nomiFileOptions) {
            console.log(report);
            let nomeFile = report.text;
            if (nomeFile === me.jsonDataReport.name) {
              me.messageErrorUpdateVersion = `Nome file già caricato, creare nuovo versioning !`;
              me.isNuovaVersioneI = true;
              me.isOKFileUpload = false;
            } else {
              me.messageErrorUpdateVersion = ``;
              me.isNuovaVersioneI = false;
              me.isOKFileUpload = true;
            }
          }
        } else {
          me.isOKFileUpload = true;
        }
      }
    },
    onConfermaFile() {
      let me = this;
      if (me.jsonDataReport) {
        me.jsonData.reportName = me.jsonDataReport.name.replace(".jasper", "");
        me.nomiFileOptions.push({
          text: me.jsonDataReport.name,
          value: me.jsonDataReport.name,
        });
        me.jsonData.nomeFile = me.jsonDataReport.name;
        me.jsonData.fileBase64 = me.jsonDataReport.base64;
        me.$refs.mdlStrutturaSelect.hide();
        me.jsonData.codiceStruttura = me.selectStrutturaModal;
        if (me.isNuovaVersioneI) {
          me.loadDataByNomeReport(me.jsonData.nomeFile);
        }
      }
    },

    onStampa() {
      let me = this;
      let printData = JSON.parse(me.jsonData.testData);
      let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
      axios
        .post(linkReport, {
          reportName: me.jsonData.reportName,
          data: printData,
        })
        .then((response) => {
          me.$refs.mdlStampaReferto.show();
          me.stampaReport = "data:application/pdf;base64," + response.data.base64;
        });
    },

    loadNomiFile(struttura) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkNomiFile;
      axios.get(link, { params: { struttura: struttura } }).then((response) => {
        if (response.data.data)
          response.data.data.list.forEach((element) => {
            me.nomiFileOptions.push({
              value: element.nomeFile,
              text: element.nomeFile,
            });
          });
      });
    },
  },
  watch: {
    "jsonData.testData": function (params) {
      let me = this;
      try {
        JSON.parse(params);
        me.jsonError = false;
      } catch (e) {
        me.jsonError = true;
      }
    },
    selectStrutturaModal: function (params) {
      let me = this;
      if (params) {
        let struttura = me.struttureRiferimentoOptions.filter((a) => a.codiceStruttura === params);
        if (struttura[0]) me.loadNomiFile(struttura[0].codiceStruttura);
        me.isStrutturaSelezionataModal = true;
        me.isOKFileUpload = false;
      }
    },
  },
};
</script>
